import { EnvVariables } from './types';

export const AcceptanceEnvVariables: EnvVariables = {
  backendUri: 'https://flow.ipractice-test.nl/api/',
  auth: {
    clientId: 'a2d6ea18-4756-43fc-a816-dff008b344d3',
    authFlow: {
      flowName: 'B2C_1A_PASSWORDLESSSIGNUPORSIGNIN',
      authority:
        'https://ipracticeacceptance.b2clogin.com/ipracticeacceptance.onmicrosoft.com/B2C_1A_PASSWORDLESSSIGNUPORSIGNIN',
    },
    knownAuthority: 'ipracticeacceptance.b2clogin.com',
    backendAuthScope: 'https://ipracticeacceptance.onmicrosoft.com/backendapi/user_access',
  },
  streamKey: 'ygc447p7t489',
  applicationInsightsConnectionString:
    'InstrumentationKey=324c8ad9-d51e-487e-8b60-51fc985315fd;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=5e8db498-1b29-4237-b30b-010a0760b17b',
};
